import { createContext, Dispatch } from "react";
import { Datasheet } from "@/api/datasheets";
import { Project } from "@/api/project";
import { StateType, WelderState, WeldListFilters } from "./types";
import { SubProject } from "@/api/subProject";
import { WelderRow, WelderWeld } from "@/api/hitachi/rbi";

export interface IWelderContext {
  state: WelderState;
  updateState: Dispatch<RbiAction>;
}

export const WelderContext = createContext<IWelderContext>({} as IWelderContext);

export type RbiAction = {
  type: StateType;
  payload?: Project | SubProject | Datasheet | WelderWeld[] | WelderRow[] | WeldListFilters | string;
};

export const reducer = (state: WelderState, action: RbiAction): WelderState => {
  switch (action.type) {
    case "Project": {
      const project = action.payload as Project;
      return { ...state, project, subProject: undefined, datasheet: undefined, operation: undefined, welds: [] };
    }
    case "SubProject": {
      const subProject = action.payload as SubProject;
      return { ...state, subProject, datasheet: undefined, operation: undefined, welds: [] };
    }
    case "Datasheet":
      return { ...state, datasheet: action.payload as Datasheet, operation: undefined, welds: [] };
    case "Operation":
      return { ...state, operation: action.payload as string, welds: [] };
    case "Welds":
      return { ...state, welds: action.payload as WelderWeld[] };
    case "Processes":
      return { ...state, processes: action.payload as WelderRow[] };
    case "Filters":
      return { ...state, filters: action.payload as WeldListFilters, welds: [], processes: [] };
    default:
      return state;
  }
};
